import * as React from 'react';
import { connect } from 'react-redux';
import { ArticleParagraph3 } from '@cian/ui-kit';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Container } from '../../components/Container';
import { Text } from '../../components/Text';
import { SIZE_16, SIZE_20, SIZE_24, SIZE_4 } from '../../constants/sizes';

import { IApplicationState } from '../../types/redux';

import { QuickLinksColumnsContainer } from './QuickLinksColumnsContainer';
import { loadPageWithNewJsonQuery } from '../../actions/location/index';
import { TTypedThunkDispatch } from '../../types/thunk';
import { IBreadcrumb, IQuickLink } from '../../types/offersData';
import { IRoomCounter, IBuildingStatus } from '../../types/newbuilding';
import { trackingActionClickAlsoLooking } from '../../actions/analytics';
import { BuilderBuildingStatuses } from './BuilderBuildingStatuses';
import { BuilderStatsByRooms } from './BuilderStatsByRooms';
import { getIsFilterUpcomingSaleEnabled } from '../../selectors/location';

interface IQuickLinksComponentStoreProps {
  quickLinks: IQuickLink[] | null;
  breadcrumbs: IBreadcrumb[];
  title: string;
  buildingStatus: IBuildingStatus[] | null;
  countsByRoom: IRoomCounter[] | null;
  isInfoSection?: boolean;
}

interface IQuickLinksComponentDispatchProps {
  setPage(url: string): void;
}

export type TQuickLinksComponentProps = IQuickLinksComponentStoreProps & IQuickLinksComponentDispatchProps;

export const QuickLinksComponent: React.FunctionComponent<TQuickLinksComponentProps> = props => {
  const { breadcrumbs, title, quickLinks, setPage, buildingStatus, countsByRoom, isInfoSection } = props;

  const hasQuickLinks = !!quickLinks && !!quickLinks.length;
  const hasBuildingStatus: boolean = !!buildingStatus && !!buildingStatus.length;
  const hasCountsByRoom: boolean = !!countsByRoom && !!countsByRoom.length;
  const hasStats = hasBuildingStatus && hasCountsByRoom;

  return (
    <Container dataMark="QuickLinksComponent" padding={`${SIZE_16} 0 ${hasQuickLinks ? SIZE_20 : 0}`} noPrint>
      <Breadcrumbs stack={breadcrumbs} />
      <Container margin={`${SIZE_24} 0 ${SIZE_16}`}>
        <Text fontSize={22} fontWeight="bold" lineHeight={28} tagName="h1">
          {title}
        </Text>
        {isInfoSection && (
          <Container margin={`${SIZE_4} 0 0 0`}>
            <ArticleParagraph3 color="gray40_100">Информационный раздел</ArticleParagraph3>
          </Container>
        )}
      </Container>
      {!hasStats && <QuickLinksColumnsContainer quickLinks={quickLinks} setPage={setPage} />}
      {hasBuildingStatus && <BuilderBuildingStatuses statuses={buildingStatus} setPage={setPage} />}
      {hasCountsByRoom && <BuilderStatsByRooms counters={countsByRoom} setPage={setPage} />}
    </Container>
  );
};

export function mapStateToProps(state: IApplicationState): IQuickLinksComponentStoreProps {
  const { seo, quickLinks, breadcrumbs, builder, builderStats } = state.offersData;

  const ifNoBuilder = seo && seo.h1 ? seo.h1 : 'Квартиры в новостройках (ЖК) в Москве';
  const title = builder ? `Новостройки от застройщика ${builder.name}` : ifNoBuilder;

  return {
    isInfoSection: getIsFilterUpcomingSaleEnabled(state),
    quickLinks: (quickLinks && quickLinks.links) || null,
    countsByRoom: (builderStats && builderStats.countsByRoom) || null,
    buildingStatus: (builder && builder.buildingStatus) || null,
    breadcrumbs,
    title,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IQuickLinksComponentDispatchProps {
  return {
    setPage: (url: string) => {
      dispatch(trackingActionClickAlsoLooking(url));
      dispatch(loadPageWithNewJsonQuery(url));
    },
  };
}

export const QuickLinksContainer = connect(mapStateToProps, mapDispatchToProps)(QuickLinksComponent);
